const initialState = {
  data: [],
  uploadError: '',
  filesLoading: false,
  loading: false,
  loaded: false,
  errors: {},
};

const updateDocument = (state, payload) => {
  const data = state.data.map((document) => {
    if (document.id === payload.id) return payload;
    return document;
  });
  return {
    ...state,
    data,
    loading: false,
  };
};

const documents = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'PHASE_RESOURCE_REQUEST':
      return initialState;
    case 'DOCUMENTS_REQUEST':
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case 'DOCUMENTS_REQUEST_SUCCESS':
      return {
        ...state,
        data: payload,
        loading: false,
        loaded: true,
      };
    case 'DOCUMENTS_REQUEST_FAILURE':
      return {
        ...initialState,
        errors: payload.errors,
      };
    case 'DOCUMENTS_FILES_UPLOAD':
      return {
        ...state,
        filesLoading: true,
        uploadError: '',
      };
    case 'DOCUMENT_RESOURCE_UPDATE_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'DOCUMENT_RESOURCE_UPDATE_SUCCESS':
      return updateDocument(state, payload);
    case 'DOCUMENTS_FILES_UPLOAD_SUCCESS':
      return {
        ...state,
        data: payload,
        filesLoading: false,
      };
    case 'APPROVE_LABOR_SHEET_SUCCESS':
      return {
        ...state,
        data: [...state.data, ...payload.document_uploads],
      };
    case 'DOCUMENTS_FILES_UPLOAD_FAILURE':
    case 'DOCUMENT_RESOURCE_UPDATE_FAILURE':
      return {
        ...state,
        filesLoading: false,
        uploadError: payload.errors,
      };
    case 'CREATE_RELATED_PHASE_SUCCESS':
    case 'REMOVE_RELATED_PHASE_SUCCESS':
    case 'PHASE_RESOURCE_CREATE_SUCCESS':
      return {
        ...state,
        loaded: false,
        data: [],
      };
    default:
      return state;
  }
};

export default documents;



// WEBPACK FOOTER //
// ./client/app/reducers/documents.js